// CoverageStatus{coverage, coveringFabricationOrder, missingQuantity, unit, operation} ->
// render-ready label (RN55, D13). The three values are exhaustive and excluding (R-9): each row
// resolves to exactly one of these three keys, never a combination.
export const coverageLabel = (row, statusLabelOf = (status) => status) => {
  const source = row || {}

  switch (source.coverage) {
    case 'COVERED':
      return { key: 'Covered', values: {} }
    case 'COVERED_BY_ORDER': {
      const order = source.coveringFabricationOrder || {}
      return {
        key: 'Covered by fabrication order {{code}} ({{status}})',
        values: { code: order.code, status: statusLabelOf(order.status) }
      }
    }
    case 'MISSING': {
      const operation = source.operation || {}
      return {
        key: 'Missing {{quantity}} {{unit}} for operation {{operation}}',
        values: { quantity: source.missingQuantity, unit: source.unit, operation: operation.name }
      }
    }
    // RN8: a coverage that did not arrive (or that this screen does not know) is not MISSING — it
    // has no label, and the caller shows a dash.
    default:
      return { key: '', values: {} }
  }
}
